var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "100%",
        height: "100%",
        stroke: "currentColor",
        viewBox: "0 0 14 19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          "stroke-width": "0",
          d: "M11 6.97656V16.9766H3V6.97656H11ZM9.5 0.976562H4.5L3.5 1.97656H0V3.97656H14V1.97656H10.5L9.5 0.976562ZM13 4.97656H1V16.9766C1 18.0766 1.9 18.9766 3 18.9766H11C12.1 18.9766 13 18.0766 13 16.9766V4.97656Z",
          fill: "currentColor",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }